import { isValidPrice } from '@domain-group/javascript-utils'

export type OrderBundleItemModel = {
  cache_key: number,
  id: number,
  options?: any,
  options_string?: string,
  order_bundle_id: number,
  price_override?: number,
  product_code?: string,
  product_name?: number,
  provider_id?: number,
  provider_price_list_id?: number,
  provider_price_list_item_id?: number,
  publication_id?: number,
  quantity?: number,
  service_id?: number,
  service_product_id?: number,
  sort?: number,
  title: string,
}

const state = {
  id: null,
  options: [],
  order_bundle_id: undefined,
  price_override: '',
  product_code: '',
  product_name: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  provider_price_list_item_id: undefined,
  publication_id: undefined,
  sort: '',
  title: '',
}

export const requiredFields = [
  { key: 'order_bundle_id' },
  { key: 'price_override', validation: (value: number | string | undefined) => (value ? isValidPrice(value) : true) },
  { key: 'title' },
]

export default state
